<template>
    <div class="cost-apply">
      <van-nav-bar
        title="费用申请"
      />
  
      <van-form @submit="onSubmit">
        <van-cell-group inset>
          <van-field
            v-model="form.title"
            name="title"
            label="申请人"
            placeholder="请输入申请人"
            :rules="[{ required: true, message: '请填写费用标题' }]"
          />
  
          <van-field
            v-model="form.carNumber"
            name="carNumber"
            label="车号"
            placeholder="请输入车号"
            :rules="[{ required: true, message: '请填写车号' }]"
          />
  
          <van-field
            v-model="form.type"
            is-link
            readonly
            name="type"
            label="费用类型"
            placeholder="请选择费用类型"
            @click="showTypePopup = true"
            :rules="[{ required: true, message: '请选择费用类型' }]"
          />
  
          <van-field
            v-model="form.amount"
            type="digit"
            name="amount"
            label="费用金额"
            placeholder="请输入费用金额"
            :rules="[
              { required: true, message: '请填写费用金额' },
              { validator: validateAmount, message: '金额必须大于0' }
            ]"
          />
  
          <van-field
            v-model="form.date"
            is-link
            readonly
            name="date"
            label="费用日期"
            placeholder="请选择费用日期"
            @click="showDatePicker = true"
            :rules="[{ required: true, message: '请选择费用日期' }]"
          />
  
          <van-field
            v-model="form.remark"
            rows="3"
            autosize
            label="申请说明"
            type="textarea"
            maxlength="200"
            placeholder="请输入申请说明"
            show-word-limit
            :rules="[{ required: true, message: '请填写申请说明' }]"
          />
        </van-cell-group>
  
        <div style="margin: 16px;">
          <van-button round block type="primary" native-type="submit">
            提交申请
          </van-button>
        </div>
      </van-form>
  
      <!-- 费用类型选择器 -->
      <van-popup v-model:show="showTypePopup" position="bottom">
        <van-picker
          :columns="typeColumns"
          @confirm="onTypeConfirm"
          @cancel="showTypePopup = false"
          show-toolbar
          title="选择费用类型"
        />
      </van-popup>
  
      <!-- 日期选择器 -->
      <van-popup v-model:show="showDatePicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="选择日期"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onDateConfirm"
          @cancel="showDatePicker = false"
        />
      </van-popup>
  
      <!-- 添加操作选择弹窗 -->
      <van-dialog
        v-model:show="showActionDialog"
        title="提交成功"
        show-cancel-button
        confirm-button-text="继续提交"
        cancel-button-text="退出"
        @confirm="resetForm"
        @cancel="goToComplete"
      >
        <div class="dialog-content" style="text-align: center; padding: 20px 0;">
          是否继续提交新的费用申请？
        </div>
      </van-dialog>
    </div>
  </template>
  
  <script>
  import { addCostApply } from '@/api/costs'
  
  export default {
    data() {
      return {
        showTypePopup: false,
        showDatePicker: false,
        currentDate: new Date(),
        form: {
          title: '',
          type: '',
          amount: '',
          date: '',
          remark: '',
          status: 'pending',
          carNumber: ''
        },
        // 费用类型选项
        typeColumns: [
          { text: '维修支出', value: 'repair' },
          { text: '厨房支出', value: 'kitchen' },
          { text: '工资支出', value: 'salary' },
          { text: '燃油支出', value: 'fuel' },
          { text: '其他支出', value: 'other' }
        ],
        typeMap: {
          '维修支出': 'repair',
          '厨房支出': 'kitchen',
          '工资支出': 'salary',
          '燃油支出': 'fuel',
          '其他支出': 'other'
        },
        // 日期范围限制
        minDate: new Date(2020, 0, 1),
        maxDate: new Date(2025, 11, 31),
        showActionDialog: false
      }
    },
    created() {
        // this.form.type = 'repair'
        // this.form.type = repair
        this.form.type = '维修支出'
    },
    methods: {
      validateAmount(val) {
        return Number(val) > 0
      },

      onTypeConfirm(value) {
        this.form.type = value.text
        this.showTypePopup = false
      },

      onDateConfirm(value) {
        this.form.date = this.formatDate(value)
        this.showDatePicker = false
      },

      formatDate(date) {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },

      
      async onSubmit() {
        try {
          const submitData = {
            ...this.form,
            type: this.typeMap[this.form.type]
          }
          const res = await addCostApply(submitData)
          if (res.code === 200) {
            this.$toast.success('提交成功')
            this.showActionDialog = true
          } else {
            this.$toast.fail(res.message || '提交失败')
          }
        } catch (error) {
          console.error('提交费用申请失败:', error)
          this.$toast.fail('提交失败，请稍后重试')
        }
      },

      resetForm() {
        const { title, type, date } = this.form
        this.form = {
          title,
          type,
          date,
          amount: '',
          remark: '',
          status: 'pending',
          carNumber: ''
        }
      },

      goToComplete() {
        this.$router.push('/costs/complete')
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .cost-apply {
    min-height: 100vh;
    background-color: #f7f8fa;
    padding-bottom: 20px;
  
    :deep(.van-cell-group) {
      margin-top: 12px;
    }
  
    :deep(.van-field__label) {
      width: 80px;
    }
  }
  </style>